
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Find the root element
const rootElement = document.getElementById("root");

// Ensure the root element exists
if (!rootElement) {
  console.error("Root element not found. Cannot mount the application.");
} else {
  // Create and render the root
  createRoot(rootElement).render(<App />);
}
